// src/PageTree.jsx
import React, { useState, useMemo } from 'react';
import { Link } from 'react-router-dom';


// src/routesData.js
export const routes = [
    { path: "/", name: "AdminPanel " },

    { path: "/upload", name: "ExcelUpload " },
    { path: "/admin", name: "Admin " },
    { path: "/login", name: "PhoneAuth " },
    { path: "/location", name: "GetLocation " },
    { path: "/stick", name: "Stick " },
    { path: "/search", name: "Search " },
    { path: "/userlist", name: "Unregistereduser " },
    { path: "/addeduser", name: "RegisteredUser " },
    { path: "/invite", name: "Invite " },
    { path: "/portfolio", name: "Portfolio " },
    { path: "/oldHomescreen", name: "OldHomescreen " },
    { path: "/testing/:id", name: "Testing " },
    { path: "/contact", name: "Contact " },
    { path: "/testport", name: "Testport " },
    { path: "/beatrainer", name: "BeATrainer " },
    { path: "/bedistributor", name: "BeDistributor " },
    { path: "/feedback/:id", name: "Feedback " },
    { path: "/filters", name: "FilterTesting " },
    { path: "/upload_course", name: "UploadCourse " },
    { path: "/upload_consumables", name: "UploadConsumables " },
    { path: "/upload_sellproducts", name: "UploadSellProducts " },
    { path: "/upload_workshop", name: "UploadWorkshopEvent " },
    { path: "/share_workshop/:id", name: "ShareWorkshop " },
    { path: "/upload_awardshow", name: "UploadAwardShow " },
    { path: "/add_mentors", name: "AddMentors " },
    { path: "/job_application", name: "JobApplication " },
    { path: "/quicklinks", name: "Quicklinks " },
    { path: "/edit_consumables", name: "EditConsumables " },
    { path: "/order_confirmation", name: "OrderConfirmation " },
    { path: "/trends", name: "Trends " },
    { path: "/oovve_champian", name: "OoveChampian " },
    { path: "/payment", name: "HomePagePayment " },
    { path: "/error", name: "PageNotFound " },
    { path: "/products", name: "ProductList " },
    { path: "/services_list", name: "ServicesList " },
    { path: "/fb", name: "WhatsappTesting " },
    { path: "/addpincode", name: "AddPincode " },
    { path: "/shop", name: "Shop " },
    { path: "/cart", name: "Cart " },
    { path: "/certificate/:id", name: "Certificate " },
    { path: "/tests", name: "Tests " },
    { path: "/analytics", name: "Analytics " },

    { path: "/mentor_data", name: "MentorData " },
    { path: "/workshop_data", name: "WorkshopData " },
    { path: "/workshop_data_hindi", name: "WorkshopDataHindi " },
    { path: "/getonrent_data", name: "GetOnRent " },
    { path: "/consumables_data", name: "ConsumablesData " },
    { path: "/course_data", name: "CourseData " },
    { path: "/promotional_data", name: "PromotionalData " },
    { path: "/freebusinesscards_data", name: "FreeBusinessCards " },
    { path: "/premiumcards_data", name: "PremiumCards " },
    { path: "/bulk_whatsapp", name: "BulkWhatsapp " },
    { path: "/graph_test", name: "GraphTest " },
    { path: "/view_app_data", name: "ViewAppData " },
    { path: "/view_requests", name: "ViewAllRequests " },
    { path: "/beauty_kit_requests", name: "BeautyKitRequest " },
    { path: "/book_demo_requests", name: "BookDemoRequest " },
    { path: "/business_card_request", name: "BusinessCardRequest " },
    { path: "/event_request", name: "EventRequest " },
    { path: "/hire_request", name: "HireRequest " },
    { path: "/mentorship_request", name: "MentorshipRequest " },
    { path: "/consumables_request", name: "ConsumablesRequest " },
    { path: "/premium_card_request", name: "PremiumCardRequest " },
    { path: "/rent_request", name: "RentRequest " },
    { path: "/workshop_registration", name: "WorkshopRegistration " },
    { path: "/workshop", name: "Workshop " },
    { path: "/workshop_hindi_reg", name: "WorkshopHindiReg " },
    { path: "/users_profile", name: "UsersProfile " },
    { path: "/csv", name: "Csv " },
    { path: "/certificate_upload", name: "CertificateUpload " },
    { path: "/portfolio_new", name: "PortfolioNew " },

    { path: "/:id", name: "NewPortfolio " },
    { path: "/gslider", name: "GlorySlider " },
    { path: "/:id/gallery", name: "ImageGallery " },
    { path: "/:id/services", name: "AllServices " },
    { path: "/:id/review", name: "ReviewPage " },
    { path: "/testingg", name: "Testingg " },
    { path: "/:id/certificates", name: "Certificates " },
    { path: "/:id/customer_review", name: "CustomerReview " },
    { path: "/testimonial_slider", name: "TestimonialSlider " },
    { path: "/toplink", name: "TopLink " },

    { path: "/footer", name: "Footer " },
    { path: "/artist/:id", name: "Artist " },
    { path: "/header", name: "Header " },
    { path: "/loan_request", name: "LoanRequest " },
    { path: "/loan_details/:id", name: "LoanDetails " },
    { path: "/user_loan_details/:id", name: "UsersLoanDetails " },
    { path: "/googlelogin", name: "GoogleLogin " },
    { path: "/emi_details/:id", name: "EmiDetails " },
    { path: "/upload_loan_application", name: "UploadLoanApplication " },
    { path: "/upload_repayment", name: "UploadRepayment " },
    { path: "/privacy_policy", name: "PrivacyPolicy " },
    { path: "/aboutus", name: "AboutUs " },
    { path: "/contactus", name: "ContactUs " },
    { path: "/portfolio_data", name: "PortfolioData " },
    { path: "/course_data_hindi", name: "CourseDataHindi " },
    { path: "/request_callback", name: "RequestCallBack " },
    { path: "/notification", name: "Notification " },
    { path: "/sidebar", name: "Sidebar " },
    { path: "/customer_data", name: "CustomerData " },
    { path: "/referred_courses", name: "ReferredCourses " },
    { path: "/signin", name: "SignIn " },
    { path: "/portfolio_analyser", name: "PortfolioAnalyser " },
    { path: "/portfolio_reviews", name: "PortfolioReviews " },
    { path: "/appointments", name: "Appointments " },
    { path: "/delete_portfolio_req", name: "DeletePortfolioRequest " },
    { path: "/website_message", name: "WebsiteMessage " },
    { path: "/app_feedback", name: "AppFeedback " },
    { path: "/appointment_booked", name: "AllAppointments " },
    { path: "/mycomponent", name: "MyComponent " },
    { path: "/send_whatsapp", name: "SendWhatsapp " },
    { path: "/create_whatsapp_template", name: "CreateWhatsappTemplate " },
    { path: "/portfolio_full_data", name: "PortfolioFullData " },
    { path: "/location_data", name: "LocationData " },
    { path: "/add_slider_images", name: "AddSliderImages " },
    { path: "/posters_created", name: "PostersCreated " },
    { path: "/appointment_analyser", name: "AppointmentAnalyser " },
    { path: "/my_business", name: "MyBusiness " },
    { path: "/workshop_reminder", name: "WorkshopReminder " },

    { path: "/upload_certificates", name: "UploadCertificates " },
    { path: "/upload_service_images", name: "UploadServiceImages " },
    { path: "/upload_recorded_video", name: "UploadRecordedVideo " },
    { path: "/push_notifications", name: "PushNotifications " },
    { path: "/clicked_logs", name: "ClickedLogs " },
    { path: "/user_based_role", name: "UserBasedRole " },
    { path: "/workshop_query", name: "WorkshopQuery " },
    { path: "/pin_workshop", name: "PinWorkshop " },
    { path: "/homepage_poster", name: "HomePagePoster " },
    { path: "/notifications", name: "Notifications " },
    { path: "/all_certificates", name: "AllCertificates " },
    { path: "/workshop_attendance", name: "WorkshopAttendance " },
    { path: "/workshop_attendance_status", name: "WorkshopAttendanceStatus " },
    { path: "/workshop_glimpses", name: "WorkshopGlimpses " },
    { path: "/workshop_event_request", name: "WorkshopEventRequest " },
    { path: "/mark_attendance/:id", name: "MarkAttendance " },
    { path: "/bridal", name: "Bridal " },
    { path: "/workshop_slider_image", name: "WorkshopSliderImages " },
    { path: "/expenses_list", name: "ExpensesList " },
    { path: "/workshop_feedback", name: "WorkshopFeedback " },
    { path: "/app_referral", name: "AppReferral " },
    { path: "/bridal_page", name: "BridalPage " },
    { path: "/bridal_artist", name: "BridalAtrist " },
    { path: "/bridal_clicks", name: "BridalClicks " },
    { path: "/tipsforyou", name: "Tips " },
    { path: "/social_media_graphics", name: "SocialMediaGraphics " },
    { path: "/banner_design", name: "FreeBannerDesign " },
    { path: "/global_notification", name: "GlobalNotification " },
    { path: "/previous_card_work", name: "PreviousCardWorks " },
    { path: "/advertise_feedback", name: "AdvertiseFeedback " },
    { path: "/advertise_download", name: "AdvertiseDownload " },
    { path: "/banner_request", name: "BannerRequest " },
    { path: "/premium_banner_request", name: "PremiumBannerRequest " },
    { path: "/smg_request", name: "SmgRequest " },
    { path: "/whatsapp_business_request", name: "WhatsappBusinessRequest " },
    { path: "/google_business_request", name: "GoogleBusinessRequest " },
    { path: "/workshop_registration_count", name: "WorkshopRegistrationFilter " },
    { path: "/shortlisted_portfolio", name: "ShortlistedPortfolios " },
    { path: "/mehndi", name: "Mehndi " },
    { path: "/jwellery", name: "Jwellery " },
    { path: "/outfit", name: "Outfit " },
    { path: "/couple_clicks", name: "CoupleClick " },
    { path: "/groom_clicks", name: "GroomClick " },
    { path: "/function_clicks", name: "FunctionClick " },
    { path: "/prewedding_clicks", name: "Prewedding " },
    { path: "/testo", name: "Testo " },
    { path: "/session_slider_images", name: "WorkshopSessionSlider " },
    { path: "/advertise_data", name: "AdvertiseData " },
    { path: "/user_last_checkin", name: "UsersLastCheckin " },
    { path: "/login_logs", name: "LoginLog " },
    { path: "/feedback_reply", name: "FeedbackReply " },
    { path: "/workshop_code", name: "WorkshopCode " },
    { path: "/sms", name: "SMSComponent " },
    { path: "/downloaded_certificate", name: "DownloadCertificate " },
    { path: "/personal_notification", name: "PersonalNotification " },
    { path: "/users_log", name: "UserLogs " },
    { path: "/payment_payu", name: "PayUForm " },

    { path: "/workshop_payment", name: "WorkshopPayment " },
    { path: "/upcoming_session", name: "UpcomingSession " },
    { path: "/paid_workshop", name: "WorkshopPaid " },
    { path: "/guidance_session", name: "GuidanceSession " },
    { path: "/get_workshop_users/:id", name: "SendCode " },
    { path: "/send_certificate_code", name: "SendCertificateCode " },
    { path: "/workshop_tag", name: "WorkshopTag " },
    { path: "/topic_request", name: "TopicRequest " },
    { path: "/advertise_slider", name: "AdvertiseSlider " },
    { path: "/previous_sm", name: "PreviousSM " },
    { path: "/custom_cards", name: "CustomCards " },
    { path: "/premium_smg_request", name: "PremiumSMG " },
    { path: "/UploadGrowForm", name: "UploadGrowForm " },


    { path: "/CourseUploadForm", name: "CourseUploadForm " },
    { path: "/add_quiz", name: "AddQuiz " },
    { path: "/add_expert", name: "ExpertUploadPage " },
    { path: "/course_enrollment", name: "EnrolledCourse " },
    { path: "/membership_tracking", name: "MembershipTracking " },
    { path: "/bookings", name: "CreateBooking " },
    { path: "/doubt_session", name: "DoubtClearingRequest " },
    { path: "/add_doubt_session", name: "AddDoubtSession " },
    { path: "/call_back_request", name: "CallBackRequest " },
    { path: "/orders_data", name: "OrdersData " },
    { path: "/community", name: "Community " },
    { path: "/send_notification", name: "SendAppNotifications " },
    { path: "/query_data", name: "QueryData " },
    { path: "/faqs_query", name: "FaqsQuery " },
    { path: "/studio_review", name: "StudioReview " },
    { path: "/enroll_user", name: "EnrollUsers " },
    { path: "/loan_remark", name: "LoanRemarks " },
    { path: "/profile_type", name: "ProfileType " },
    { path: "/update_course_attendance", name: "UpdateCourseAttendance " },
    { path: "/all_course_data/:course_name", name: "AllCourseData " },
    { path: "/custom_enrollment", name: "EnrollCourse " },
    { path: "/course_video_update", name: "CourseVideoUpdate " },
    { path: "/course_attendance_update", name: "CourseAttendanceUpdate " },
    { path: "/course_timestamp_update", name: "CourseTimestampUpdate " },
    { path: "/grow_data", name: "GrowDraft " },
    { path: "/grow_all_data", name: "GrowAllData " },
    { path: "/users_course_data", name: "UsersCourseData " },
    { path: "/tracking", name: "TrackingPage " },
    { path: "/analytics_details", name: "AnalyticsDetails " },
    { path: "/page_visit", name: "PageVisitsScreen " },
    { path: "/dashbaordall", name: "DashboardAll " },
    { path: "/remove_duplicate", name: "RemoveDuplicatePhoneNumbers " },
    { path: "/view_all_courses", name: "ViewAllCourses " },
    { path: "/bulk_push", name: "BulkPush " },
    { path: "/finance_query", name: "FinanceQuery " },
    { path: "/certificate_downloads", name: "CertificateDownload " },
    { path: "/add_growcard", name: "CardManager " },
    { path: "/apptopbanner", name: "AppTopBanner " },
    { path: "/extend_membership", name: "ExtendMembership " },
    { path: "/whatsapp_sender", name: "WhatsappSender " },
    { path: "/updxateCourse", name: "UpdateCourse " },
    { path: "/invoice/:id", name: "Invoice " },
    { path: "/transaction_history", name: "TransactionHistory " },
    { path: "/requested_topics", name: "RequestedTopics " },
    { path: "/know_more_about_course", name: "KnowMoreAboutCourse " },
    { path: "/active_membership", name: "ActiveMembersTable " },
    { path: "/downloaded_certificate_data", name: "DownloadCertificateNew " },
    { path: "/workshop_registrations", name: "WorkshopRegistrations " },
    { path: "/funder_login", name: "FunderLogin " },
    { path: "/sidemenu", name: "SideMenu " },
    { path: "/user_loan_details_modify/:id", name: "ModifyLoanDetails " },
    { path: "/appreferralsubmit", name: "AppReferralSubmit " },
    { path: "/bulkuploadusers", name: "BatchUploadUsers " },
    { path: "/FunderUsersListPage", name: "FunderUsersListPage " },
    { path: "/BulkReferralUpdater", name: "BulkReferralUpdater " },
    { path: "/BulkAgeRangeUpdate", name: "BulkAgeRangeUpdate " },
    { path: "/UdyamRegistrationData", name: "UdyamRegistrationData " },
    { path: "/EcommerceSupportData", name: "EcommerceSupportData " },
    { path: "/editcoursepage", name: "EditCoursePage " },
    { path: "/add_mentorship_session", name: "AddMentorshipSession " },
    { path: "/VisitingCardEditor", name: "VisitingCardEditor " },
    { path: "/menugroup", name: "MenuGroup " },
    { path: "/refreshdownloads", name: "RefreshDownloads " },
    { path: "/workshophindiversion", name: "WorkshopHindiVersion " },
    { path: "/check_app_downloads", name: "BulkCheckActivity " },
    { path: "/UpdateParlourLocation", name: "UpdateParlourLocation " },
    { path: "/PortfolioPage", name: "PortfolioPage " },
    { path: "/ExcelUploader", name: "ExcelUploader " },
    { path: "/atoscert", name: "AtosCert " },
    { path: "/atos_certificate_list", name: "AtosCertificateList " },
    { path: "/tabform", name: "TabForm " },
    { path: "/RegistrationForm", name: "RegistrationForm " },
    { path: "/registration_form_list", name: "RegistrationFormList " },
    { path: "/formedit/:id", name: "TabFormEdit " },
    { path: "/registration_form_status", name: "FormRegistrationStatus " },
    { path: "/test/ok/ApplicationForm/:id", name: "ApplicationForm " },
]


export default function PageTree() {
    const [searchTerm, setSearchTerm] = useState('');

    const filtered = useMemo(() => {
        const term = searchTerm.toLowerCase();
        if (!term) return routes;
        return routes.filter(r =>
            r.path.toLowerCase().includes(term)
            || (r.name && r.name.toLowerCase().includes(term))
        );
    }, [searchTerm]);

    return (
        <div style={{ padding: '20px' }}>
            <h2>All Routes</h2>
            <input
                type="text"
                placeholder="Search by path or page name..."
                value={searchTerm}
                onChange={e => setSearchTerm(e.target.value)}
                style={{
                    padding: '8px 12px',
                    width: '100%',
                    maxWidth: '400px',
                    marginBottom: '20px',
                    marginTop: '1rem',
                    fontSize: '16px',
                }}
                className='form-control'
            />

            <ul style={{ listStyleType: 'none', padding: 0 }}>
                {filtered.map((r, idx) => (
                    <li key={idx} style={{ margin: '8px 0' }}>
                        <Link to={r.path} style={{ textDecoration: 'none', color: '#0077cc' }}>
                            <strong>{r.path}</strong> — <span>{r.name}</span>
                        </Link>
                    </li>
                ))}
            </ul>

            {filtered.length === 0 && (
                <p>No routes found for “{searchTerm}”.</p>
            )}
        </div>
    );
}
